import { ApolloClient } from "@apollo/client";
import { UPDATE_ROLE_PERMISSIONS } from "@src/domain/graphql";
import type { UpdateRolePermissionsDTO } from "@src/domain/dto/rolePermissions";
import type {
  IRolePermissionsRepository,
  UpdateRolePermissionsResult,
} from "@src/domain/repositories/rolePermissions";

interface UpdateRolePermissionsResponse {
  updateRolePermissions: UpdateRolePermissionsResult;
}

export class RolePermissionsRepository implements IRolePermissionsRepository {
  private readonly client: ApolloClient;

  constructor(client: ApolloClient) {
    this.client = client;
  }

  async updateRolePermissions(
    params: UpdateRolePermissionsDTO,
  ): Promise<UpdateRolePermissionsResult> {
    const result = await this.client.mutate<UpdateRolePermissionsResponse>({
      mutation: UPDATE_ROLE_PERMISSIONS,
      variables: {
        roleId: params.roleId,
        featureId: params.featureId,
        isActive: params.isActive,
        permissionId: params.permissionId,
      },
    });

    if (!result.data?.updateRolePermissions) {
      throw new Error("Failed to update role permissions");
    }

    this.client.cache.evict({ id: "ROOT_QUERY", fieldName: "rolePermissions" });
    return result.data.updateRolePermissions;
  }
}
